export const filterOption = (input: string, option?: { label: string; value: string }) =>
  normalizeText((option?.label ?? "").toLowerCase()).includes(normalizeText(input.toLowerCase()))

export const normalizeText = (text: string) => {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/đ/g, "d")
    .replace(/Đ/g, "D")
}

const VIDEO_EXTENSIONS = [".mp4", ".webm", ".ogg", ".mov", ".avi", ".mkv", ".wmv", ".flv"]

export const isVideoFile = (media: { name?: string; mimeType?: string; url?: string }): boolean => {
  if (media.mimeType) {
    return media.mimeType.startsWith("video/")
  }
  if (media.name) {
    const ext = media.name.toLowerCase().slice(media.name.lastIndexOf("."))
    return VIDEO_EXTENSIONS.includes(ext)
  }
  if (media.url) {
    const ext = media.url.toLowerCase().slice(media.url.lastIndexOf("."))
    return VIDEO_EXTENSIONS.includes(ext)
  }
  return false
}